import {CUSTOMER_TYPE_D2B} from '../constants'

export const isD2BCustomer = (enabled, customer) =>
    enabled && customer?.c_isD2BCustomer && customer?.c_accountType === CUSTOMER_TYPE_D2B
